export default __webpack_public_path__ + "static/media/Rollover.67e88c78.jpg";